PhotoModalService.$inject = ['ModalService'];

export function PhotoModalService(ModalService) {
  var service = {
    openAddPhotosModal: openAddPhotosModal,
  };

  return service;

  ////////////////////////

  function openAddPhotosModal(apiUrl, items, successCallback) {
    ModalService.showModal({
      templateUrl: './app/ajs/_shared/components/photo-list/modals/add-photos-modal.html',
      controller: OpenAddPhotosModalCtrl,
      controllerAs: 'vm',
      inputs: {
        apiUrl: apiUrl,
        items: items,
        successCallback: successCallback,
      },
    }).then(function (modal) {
      modal.element.modal();

      // modal.closex.then(function(data) {
      //     successCallback(data);
      // });
    });

    OpenAddPhotosModalCtrl.$inject = [
      '$element',
      'CONFIGURATIONS',
      'FileUploader',
      'LocalStoreService',
      'apiUrl',
      'items',
      'successCallback',
    ];
  }

  function OpenAddPhotosModalCtrl(
    $element,
    CONFIGURATIONS,
    FileUploader,
    LocalStoreService,
    apiUrl,
    items,
    successCallback
  ) {
    const vm = this;

    vm.apiUrl = apiUrl;
    vm.items = items;

    var config = CONFIGURATIONS;

    vm.defaultContentLanguage = config.DEFAULT_CONTENT_LANGUAGE;

    // Max file size
    vm.maxFileSize = config.IMAGE_MAX_SIZE / 1024 / 1024;

    var token = LocalStoreService.token('cu') || null;

    // Upload the new image
    var uploader = null;

    vm.uploader = new FileUploader({
      headers: {
        Authorization: 'Bearer ' + token,
      },
      url: apiUrl + '?lang=' + vm.defaultContentLanguage,
      filters: [],
      alias: 'image',
    });

    uploader = vm.uploader;

    // File must be jpeg or png
    uploader.filters.push({
      name: 'imagefilter',
      fn: function (item) {
        return item.type === 'image/jpeg' || item.type === 'image/png';
      },
    });

    // File must not be larger than some size
    uploader.filters.push({
      name: 'sizeFilter',
      fn: function (item) {
        vm.errorFileSize = false;
        if (item.size > config.IMAGE_MAX_SIZE) {
          vm.errorFileSize = true;
          return false;
        }
        return true;
      },
    });

    // Success file upload
    uploader.onSuccessItem = function (fileItem, response) {
      // Do not remove fileItem -> cache issue
      vm.items = vm.items || [];

      vm.items.push(response);
    };

    //  On all loaded when uploading an entire queue
    uploader.onCompleteAll = function () {
      $element.modal('hide');
      successCallback(vm.items);

      // close(vm.items, 500);
    };
  }
}
